import { Component, Inject, OnInit } from '@angular/core';
import {
  FormsModule,
  ReactiveFormsModule,
  UntypedFormBuilder,
  Validators,
} from '@angular/forms';
import { Router, RouterLink } from '@angular/router';
import { KeywordsAndConstants } from '../../../core/keywords-and-constants';
import { LocalStorageService } from '../../../network/services/local-storate.service';
import { CommonModule, DOCUMENT } from '@angular/common';
import { LoginRequest } from '../../../models/request/login-request';
import { JwtHelperService } from '@auth0/angular-jwt';
import { SideBarService } from '../../../network/services/sidebar.service';
import { GenericListResponse } from '../../../models/generic-list-response';
import { AccessControlCategory } from '../../../models/access-control.model';
import { LoginService } from '../../../network/services/login.service';
import { DialogUtil } from '../../../utils/dialog-utils';
import { HttpClientModule } from '@angular/common/http';
import { ErrorAction } from '../../../enums/error-action';
import { MessageType } from '../../../enums/message-type';

@Component({
  selector: 'app-login',
  standalone: true,
  imports: [
    FormsModule,
    ReactiveFormsModule,
    CommonModule,
    RouterLink,
    HttpClientModule,
  ],
  templateUrl: './login.component.html',
  styleUrl: './login.component.scss',
})
export class LoginComponent implements OnInit {
  submitted: any = false;
  error: any = '';
  returnUrl!: string;
  password = 'password';
  show = false;
  uuid: any;

  constructor(
    private formBuilder: UntypedFormBuilder,
    private router: Router,
    private constants: KeywordsAndConstants,
    private _localStorageService: LocalStorageService,
    public _loginService: LoginService,
    public _sideBarService: SideBarService,
    private dialog: DialogUtil,

    @Inject(DOCUMENT) private document: Document
  ) {
    this._localStorageService.deviceInformation();
    const localStorage = document.defaultView?.localStorage;
    if (localStorage) {
      if (
        localStorage.getItem(this.constants.LocalStorageToken) &&
        localStorage.getItem(this.constants.isLoginType)
      ) {
        this.router.navigate(['/dashboard']);
      }
    }
  }

  ngOnInit() {
    // this.password = 'password';
  }

  loginForm = this.formBuilder.group({
    emailId: ['', [Validators.required, Validators.email]],
    password: ['', [Validators.required]],
  });

  get f() {
    return this.loginForm.controls;
  }

  onShowHideIcon() {
    //this.show = !this.show;
    if (this.password === 'password') {
      this.password = 'text';
      this.show = true;
    } else {
      this.password = 'password';
      this.show = false;
    }
  }

  onSubmit() {
    this.submitted = true;
    this.uuid = localStorage.getItem('uniqueIdentifierId');

    Object.assign(this.loginForm.value, {
      clientDevicePlatform: this._localStorageService.platform,
      deviceUserAgent: this._localStorageService.deviceUserAgent,
      uniqueIdentifierId: this.uuid,
    });

    const newLoginValue = new LoginRequest();
    newLoginValue.set(this.loginForm.value);
    if (this.loginForm.invalid) {
      return;
    } else {
      this._loginService.login(newLoginValue).subscribe(
        (res) => {
          localStorage.setItem(
            this.constants.LocalStorageToken,
            JSON.stringify(res.token)
          );
          localStorage.setItem(
            this.constants.LocalStorageRefreshToken,
            JSON.stringify(res.refreshToken)
          );
          this._localStorageService.backUpToken = JSON.stringify(res.token);
          this._localStorageService.backUpRefreshToken = JSON.stringify(
            res.refreshToken
          );
          const helper = new JwtHelperService();
          const decodedToken = helper.decodeToken(res.token);
          localStorage.setItem(this.constants.isLoginType, decodedToken.type);
          this._loginService.user().subscribe((user: any) => {
            localStorage.setItem(
              this.constants.LocalStorageUserInfo,
              JSON.stringify(user)
            );
            this.getSideBarList();
          });
        },
        (error) => {
          if (error.errorAction != ErrorAction.HANDLED) {
            this.dialog.showToast(error.message, MessageType.ERROR);
          }
        }
      );
    }
  }

  getSideBarList() {
    this._sideBarService
      .getbyCategory()
      .subscribe((res: GenericListResponse<AccessControlCategory>) => {
        const filteredAccessControlCategories = res.data.filter((item: any) => {
          return item.shouldShow;
        });
        this.constants.byCategoryValue = filteredAccessControlCategories;
        this.constants.byCategoryValue.sort((a: any, b: any) => {
          return a.indexOrder - b.indexOrder;
        });
        this.constants.byCategoryValue.forEach((e: any) => {
          this.accessControl(e);
        });
        localStorage.setItem(
          this.constants.byCategory,
          JSON.stringify(this.constants.byCategoryValue)
        );
        this.router.navigate(['/dashboard']);
      });
  }

  accessControl(e: any) {
    var pageUrlFromAccessControlsList = '';
    e.accessControls.forEach((val: any) => {
      var method = val.method.substring(0, val.method.lastIndexOf('/') + 1);
      val.method = method.slice(0, -1);
      pageUrlFromAccessControlsList = val.method;
    });
    e.unreadCount = '';
    if (pageUrlFromAccessControlsList != '') {
      pageUrlFromAccessControlsList = pageUrlFromAccessControlsList.replace(
        /[A-Z]+(?![a-z])|[A-Z]/g,
        ($, ofs) => (ofs ? '-' : '') + $.toLowerCase()
      );
      e.pageUrl = pageUrlFromAccessControlsList;
    } else {
      e.pageUrl = e.pageUrl.replace(
        /[A-Z]+(?![a-z])|[A-Z]/g,
        ($: any, ofs: any) => (ofs ? '-' : '') + $.toLowerCase()
      );
    }
    if (e.subCategories.length > 0) {
      e.subCategories = e.subCategories.filter(
        (item: any) => item.shouldShow === true
      );
      e.subCategories.sort((a: any, b: any) => {
        return a.indexOrder - b.indexOrder;
      });
      e.subCategories.forEach((subCategoriesval: any) => {
        this.accessControl(subCategoriesval);
      });
    }
  }
}
